<form class="d-flex">
  <mat-form-field
    class="flex-grow-1"
    [ngClass]="{ 'gl-block': value && value.entity_type && value.entity_type === 'PATIENT' }"
    [appearance]="appearance"
  >
    <mat-label>{{ label }}</mat-label>
    <mat-chip-list
      *ngIf="chipList"
      #chipList
      aria-label="Participant selection"
      [formControl]="controlObject"
      [disabled]="readOnly"
      [required]="required"
    >
      <mat-chip *ngFor="let object of objects" (removed)="remove(object)" [removable]="!readOnly">
        <div
          [ngClass]="{ 'gl-block': object && object.type && object.type === 'PATIENT' }"
          [innerHTML]="
            (chipOptionFormatter ? chipOptionFormatter(object) : optionFormatter(object))
              | safe : 'html'
          "
        ></div>
        <mat-icon matChipRemove *ngIf="!readOnly">cancel</mat-icon>
      </mat-chip>
      <input
        style="border: none; outline: none"
        matInput
        [matAutocomplete]="autoRecorder"
        #recorderInput
        [formControl]="inputCtrl"
        (focus)="onFocus(); $event.stopPropagation()"
        [placeholder]="placeholder"
        [readonly]="readOnly"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (blur)="handleBlur()"
      />
    </mat-chip-list>
    <input
      *ngIf="!chipList"
      matInput
      [matAutocomplete]="autoRecorder"
      #recorderInput1
      [formControl]="controlObject"
      (keyup)="onChange($event)"
      (focus)="onFocus(); $event.stopPropagation()"
      [placeholder]="placeholder"
      [readonly]="readOnly"
      [required]="required"
      (blur)="handleBlur()"
      [ngStyle]="{
        'background-color':
          dataBefore && dataAfter
            ? (dataBefore | highlighted : dataAfter : 'normal_case')
              ? '#f5ebc4'
              : ''
            : ''
      }"
    />
    <button
      [hidden]="isLoading.asObservable() | async"
      *ngIf="!chipList && controlObject.value && !readOnly"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      (click)="controlObject.setValue(null); inputCtrl.setValue(null); selectedRecorder()"
    >
      <mat-icon>close</mat-icon>
    </button>
    <mat-spinner
      matSuffix
      [diameter]="18"
      style="float: right; margin-left: 8px"
      *ngIf="isLoading.asObservable() | async"
    ></mat-spinner>
    <mat-autocomplete
      autoActiveFirstOption
      #autoRecorder="matAutocomplete"
      (optionSelected)="selectedRecorder()"
      [displayWith]="valueFormatter"
      [panelWidth]="panelWidth"
    >
      <mat-option
        *ngIf="optionHeader"
        [innerHtml]="optionHeader | safe : 'html'"
        [disabled]="true"
        style="min-width: 800px !important"
        class="bg-light-primary"
      ></mat-option>
      <mat-option
        *ngFor="let record of filteredItems | async"
        [value]="record"
        [disabled]="isSelected(record)"
        [class.border-bottom]="optionHeader"
      >
        <div
          [ngClass]="{
            'gl-block': record && record.entity_type && record.entity_type === 'PATIENT'
          }"
          [innerHTML]="optionFormatter(record) | safe : 'html'"
        ></div>
      </mat-option>
      <mat-option
        disabled="true"
        *ngIf="(filteredItems | async).length == 0 && !(isLoading | async)"
        [value]="0"
        [class.border-bottom]="optionHeader"
      >
        {{ inputCtrl.value && inputCtrl.value.length ? 'No Match' : 'Start typing to Search' }}
      </mat-option>
    </mat-autocomplete>
    <mat-hint align="start" *ngIf="hint">
      {{ hint }}<strong>{{ hintStrong }}</strong>
    </mat-hint>
    <mat-error
      *ngIf="showError && required && controlObject.touched && controlObject.hasError('required')"
    >
      {{ label }} field is required
    </mat-error>
  </mat-form-field>
  <div [hidden]="!optionSearchFields?.length" class="search-fields">
    <button
      matTooltip="Search By"
      class="btn btn-icon btn-light ml-2"
      (click)="$event.stopPropagation(); searchField.open()"
    >
      <i class="flaticon-search"></i>
    </button>
    <mat-select #searchField>
      <mat-option *ngFor="let option of optionSearchFields" [value]="option.value">{{
        option.label
      }}</mat-option>
    </mat-select>
  </div>
</form>
